$(document).ready(function(){
    var vczapiFullCalendar = {
        init: function init() {
          this.cacheDOM();

          if (this.$calendarEl.length > 0) {
            this.renderCalendar();
          }
        },
        cacheDOM: function cacheDOM() {
          this.meetings = [];
          this.$calendarEl = $('.vczapi-pro-calendar-cmiscp');
          window.tippyInstances = [];
        },
        renderCalendar: function renderCalendar() {
          var lang = document.documentElement.lang;
          this.$calendarEl.each(function (i, elementObj) {
            var calendarInstance = $(this);
            var calendar_default_view = calendarInstance.data('calendar_default_view');
            var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            var calendarOptions = {
              initialView: calendar_default_view,
              initialDate: new Date(),
              locale: lang,
              // EDIT Lucidcircus
              contentHeight: 'auto',
              events: {
                url: vczapi_pro.ajaxurl + '?action=vczapi_get_calendar_meetings',
                extraParams: {
                  author: calendarInstance.data('author'),
                  show: calendarInstance.data('show'),
                  timezone: timezone
                }
              },
              loading: function loading(isLoading) {
                var $currentCalendar = $(this.el);

                if (isLoading) {
                  $currentCalendar.parent('.vczapi-pro-calendar-container').find('.vczapi-pre-loader').show();
                } else {
                  $currentCalendar.parent('.vczapi-pro-calendar-container').find('.vczapi-pre-loader').hide();
                }
              },
              eventClick: function eventClick(info) {
                info.jsEvent.preventDefault();

                if (elementObj.dataset.hasOwnProperty('show_popup') && elementObj.dataset.show_popup === 'yes') {
                  tippyInstances.forEach(function (instance) {
                    instance.destroy();
                  });
                  tippyInstances.length = 0; // clear it

                  var templateEl = $(this.el).parent().find('.vczapi-calendar-tpl');
                  var template = templateEl[0];
                  var template_string = template.innerHTML;
                  var event = info.event;
                  var eventExtendedProps = event.extendedProps;
                  var data = {
                    title: event.title
                  };

                  for (var property in eventExtendedProps) {
                    if (eventExtendedProps.hasOwnProperty(property)) {
                      data[property] = eventExtendedProps[property];
                    }
                  }

                  var content = placeholders(template_string, data);
                  var tooltip = tippy(info.el, {
                    content: '<div class="vczapi-calendar-tooltip">' + content + '</div>',
                    interactive: true,
                    allowHTML: true,
                    theme: 'light',
                    trigger: 'click',
                    zIndex: 99999,
                    showOnCreate: true,
                    popperOptions: {
                      strategy: 'fixed',
                      container: 'body',
                      arrow: false
                    }
                  });
                  window.tippyInstances = tippyInstances.concat(tooltip);
                } else if (elementObj.dataset.hasOwnProperty('show_popup') && elementObj.dataset.show_popup === 'no') {
                  window.location = info.event.url;
                }
              },
              dateClick: function(info) {
                  if(info.view.type == 'dayGridMonth'){
                    var moreLink = $(info.dayEl).find('a.fc-daygrid-more-link').first();
                    if(moreLink.length){
                      moreLink.get(0).click();
                    }
                    else {
                      var firstEvent = $(info.dayEl).find('a.fc-daygrid-event').first();
                      if(firstEvent.length){
                          firstEvent.get(0).click();
                      }
                    }
                      
                  }
              },
              views: {
                // EDIT Lucidcircus
                dayGridMonth: {
                  dayMaxEventRows: 1,
                  moreLinkContent:function(args){
                        return calendarInstance.data('more_link_text');
                  },
                  eventTimeFormat: {
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: 'short'
                  }
                },
                timeGridWeek: {
                    slotEventOverlap: false
                },
                timeGridDay: {
                    slotEventOverlap: false
                }
              }
            };
            var show_calendar_views = calendarInstance.data('show_calendar_views');

            if (show_calendar_views === 'yes') {
              calendarOptions.headerToolbar = {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
              };
            }

            var calendar = new FullCalendar.Calendar(calendarInstance[0], calendarOptions); //console.log(calendar);

            calendar.render();
          });
        }
    };
    
    vczapiFullCalendar.init();
});